import { useQuery } from "@tanstack/react-query";
import { getTeam } from "../../http/endpoints";
import { Team } from "../../redux/team";

export const TEAM_QUERY_KEY = ["team"];

function useTeam<T = Team>(
  options: {
    select?: (team: Team) => T;
    enabled?: boolean;
  } = { enabled: true },
) {
  return useQuery({
    queryKey: TEAM_QUERY_KEY,
    queryFn: () => getTeam(),
    select: options?.select,
    enabled: options?.enabled,
  });
}

export default useTeam;
